import { Button } from "@repo/ui";
import { useAuth } from "@stardeck-customer-apps/project-auth";
import { useNavigate } from "react-router-dom";

import { useTestAuthApi } from "@/lib/queries/use-test-auth-api";

export function Home() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const testApiMutation = useTestAuthApi();

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-3xl font-bold">Hello Stardeck</h1>

      <div className="space-y-4">
        <div className="flex gap-4 items-center">
          <Button onClick={() => testApiMutation.mutate()} disabled={testApiMutation.isPending}>
            {testApiMutation.isPending ? "Testing..." : "Test Authenticated API"}
          </Button>
          {!isAuthenticated && (
            <span className="text-sm text-gray-500">(You'll need to log in first)</span>
          )}
        </div>

        {testApiMutation.data && (
          <div className="p-4 bg-gray-100 dark:bg-gray-800 rounded-lg">
            <h3 className="font-semibold mb-2">API Response:</h3>
            <pre className="text-sm overflow-auto">
              {JSON.stringify(testApiMutation.data, null, 2)}
            </pre>
          </div>
        )}

        {testApiMutation.error && (
          <div className="p-4 bg-red-100 dark:bg-red-900 rounded-lg">
            <h3 className="font-semibold mb-2 text-red-800 dark:text-red-200">Error:</h3>
            <pre className="text-sm overflow-auto text-red-700 dark:text-red-300">
              {testApiMutation.error.message}
            </pre>
          </div>
        )}
      </div>

      <div className="flex gap-4">
        {isAuthenticated ? (
          <Button onClick={() => navigate("/admin")} variant="outline">
            Go to Admin Dashboard
          </Button>
        ) : (
          <Button onClick={() => navigate("/login")} variant="outline">
            Log In
          </Button>
        )}
      </div>
    </div>
  );
}
